import { EventInstructorDTO } from '@/data/dtos/Events/EventInstructorDTO';
import { EventTagDTO } from '@/data/dtos/Events/EventTagDTO';

export class EventSessionDTO {
	constructor(
		public multiLine: boolean,
		public from: string,
		public to: string,
		public title: string,
		public description: string | null = null,
		public instructors: EventInstructorDTO[] | null = null,
		public tags: EventTagDTO[] | null = null,
	) {}

	public getHours(): string {
		return `${this.from} - ${this.to}`;
	}
}
